// extracted by mini-css-extract-plugin
export default {"display-percent-wrapper":"BinaryRatingRecipeScore-module__display-percent-wrapper__eOIar","lowercase":"BinaryRatingRecipeScore-module__lowercase__SHFVi"};